<template>
  <BCard no-body class="w-100">
    <BCardBody class="d-flex justify-content-between align-items-center dashboard-profile">
      <div class="d-flex align-items-center">
      <div class="dashboard-image">
        <input
          type="file"
          ref="fileInput"
          name="userProfile"
          style="display: none"
          @change="handleFileUpload"
        />
        <img
          :src="dashboardImage"
          alt="img"
          class="dashboard-avatar-img rounded-circle dashboard-upload"
        />
        <div @click="$refs.fileInput.click()">
          <img
            src="@/assets/images/portfolio/Group 358.svg"
            alt="img"
            class="dashboard-setting dashboard-avatar-img rounded-circle border border-1"
          />
        </div>
      </div>
        <div>
          <span class="dashboard-heading d-block">
            {{ dashboardName }}'s {{ dashboardSurName }}
          </span>
          <div
          v-if="
            planType === 'Prime Growth' ||
            planType === 'Prime Essentials' ||
            planType === 'Prime-registered'
          "
          class="dashboard-plan-container"
        >
          <span class="dashboard-plan">
            <img
              v-if="!isSmallScreen"
              src="@/assets/images/portfolio/Frame133.svg"
              alt="Frame"
            />
            Subscription Active
          </span>
        </div>
        <div
          v-else-if="planType === 'Prime Trial'"
          class="dashboard-plan-container"
        >
          <span class="dashboard-plan">
            <img
              v-if="!isSmallScreen"
              src="@/assets/images/portfolio/Frame133.svg"
              alt="Frame 133"
            />
            {{ planType }}
          </span>
        </div>
        </div>
      </div>
      <div class="text-end">
       
        <div class="custom-dropdown rounded mb-1" v-click-outside="closeDropdown" v-if="hasGraphPoints">
          <button 
            class="dropdown-button" 
            @click="toggleDropdown"
            type="button"
          >
            {{ selectedHoldingText }}
            <span class="dropdown-arrow">▼</span>
          </button>
          <div v-if="isDropdownOpen" class="dropdown-menu-custom">
            <div class="dropdown-item-custom" @click="selectHoldingType('all')">
              All Holdings
            </div>
            <div class="dropdown-item-custom" @click="selectHoldingType('mutualfunds')">
              Mutual Funds
            </div>
            <div class="dropdown-item-custom" @click="selectHoldingType('stocks')">
              Stocks
            </div>
          </div>
        </div>
      </div>
    </BCardBody>
  </BCard>
</template>


<script>
import { mapGetters } from "vuex";

export default {
  name: "UserProfile",
  data() {
    return {
      dashboardName: "",
      planType: "",
      expiryDate: "",
      expiryDay: "",
      jsonData: null,
      value: "",
      rupeeSymbol: "₹",
      perSymbol: "%",
      dashboardSurName: "Dashboard",
      enabled: false,
      dashboardImage: require("@/assets/images/portfolio/Profile.jpg"),
      baseURL: process.env.VUE_APP_BASE_URL,
      planLink: `${process.env.VUE_APP_BASE_URL}/prime-pricing/`,
      isSmallScreen: window.innerWidth <= 420,
      isDropdownOpen: false,
    };
  },
  directives: {
    clickOutside: {
      mounted(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unmounted(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
  computed: {
    ...mapGetters(["userProfile", "holdingType", "myPortfolio", "portfolioType"]),
    selectedHoldingText() {
      const holdingTexts = {
        all: "All Holdings",
        mutualfunds: "Mutual Funds",
        stocks: "Stocks"
      };
      return holdingTexts[this.holdingType] || "All holdings";
    },
    hasGraphPoints() {
      const portfolio = this.portfolioType === "own" 
        ? this.myPortfolio?.ownPortfolio 
        : this.myPortfolio?.familyPortfolio;
      const graphSection = portfolio?.graphSection || [];
      return graphSection.length > 0;
    },
    formattedExpiryDate() {
      const date = new Date(this.expiryDate);
      const day = date.getDate();
      const month = date.toLocaleString("default", { month: "short" });
      const year = date.getFullYear().toString().slice(-2);

      if (this.isSmallScreen) {
        return `${day}${month}${year}`;
      } else {
        return this.expiryDate;
      }
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    selectHoldingType(type) {
      this.$store.commit("SETHOLDINGTYPE", type);
      this.isDropdownOpen = false;
    },
    changeHoldingType(type) {
      this.$store.commit("SETHOLDINGTYPE", type);
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const formData = new FormData();
        formData.append("image", file);
        this.uploadImage(formData);
      }
    },

    async uploadImage(formData) {
      const baseURL = process.env.VUE_APP_BASE_URL;
      const action = "dashboard_userProfile_image";
      try {
        const response = await fetch(
          `${baseURL}/wp-admin/admin-ajax.php?action=${action}`,
          {
            method: "POST",
            body: formData,
          }
        );

        const result = await response.json();
        if (result.success) {
          this.dashboardImage = result.data.url;
        } else {
          console.error("Upload failed:", result.data.message);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    },
    handleResize() {
      this.isSmallScreen = window.innerWidth <= 420;
    },
    processuserProfileData(data) {
      try {
        if (Object.keys(data).length > 0) {
          this.dashboardName = data.display_name;
          this.planType = data.prime_status;
          this.expiryDate = data.subNextdate;
          this.expiryDay = data.days_until_next_payment;
          this.dashboardImage = data.user_profile_image || this.dashboardImage;
        }
      } catch (error) {
        console.error("Error processing data:", error.message);
      }
    },
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    userProfile: {
      handler(userValue) {
        this.processuserProfileData(userValue);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>

.custom-dropdown {
  position: relative;
  display: inline-block;
  border: 1px solid grey;
}

.dropdown-button {
  background: transparent;
  border: none;
  color: #00a3d9;
  font-weight: 500;
  font-size: 10px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.dropdown-button:focus {
  outline: none;
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.2s ease;
}

.dropdown-menu-custom {
  position: absolute;
  top: 100%;
  right: 0;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-top: 5px;
  z-index: 1000;
  overflow: hidden;
}

.dropdown-item-custom {
  padding: 8px 16px;
  cursor: pointer;
  color: #333;
  font-size: 14px;
  transition: background-color 0.2s ease;
  white-space: nowrap;
}


.dashboard-text {
  font-size: 12px;
}

@media screen and (max-width: 450px) {
  .dashboard-valid {
    font-size: 12px;
  }
}

.btn-custom {
  background-color: #01a2d9;
  border-color: #01a2d9;
  color: white;
}

.btn-custom:hover {
  background-color: #01a2d9;
  border-color: #01a2d9;
  color: white;
}

.shine-tag {
  position: relative;
  overflow: hidden;
  background-image: linear-gradient(120deg, rgba(255,255,255, 0) 30%, rgba(255,255,255, .8), rgba(255,255,255, 0) 70%);
  background-size: 200% 200%;
  animation: shine 1s ease-in-out infinite;
}

@keyframes shine {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.dashboard-upload {
  height: 50px;
  width: 50px;
  border: 10px solid transparent;
  background-origin: border-box;
  background-clip: content-box, border-box;
  background-image: linear-gradient(white, white),
    linear-gradient(0deg, #012e40 0%, #015b7b 38%, #006a8e 51%, #00a3d9 100%);
  border-width: medium;
}

.dashboard-setting {
  position: absolute;
  bottom: 48px;
  cursor: pointer;
  left: 50px;
}

.dashboard-settings {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 7px;
  right: 5px;
  font-size: 15px;
}

.dashboard-profile {
  background: linear-gradient(180deg, #f6fdff 0%, #e2f9ff 100%);
  border-radius: 5px;
  padding: 0px 8.6px;
}

.dashboard-image {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.dashboard-heading {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  color: #012e40;
  margin-bottom: 4px;
}

.dashboard-plan-container {
  display: flex;
  align-items: center;
}

.dashboard-plan {
  padding: 2px 8px;
  background: white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  color: #012e40;
  display: flex;
  align-items: center;
  margin-right: 10px;
}

.dashboard-plan img {
  margin-right: 5px;
}

.dashboard-valid {
  font-size: 12px;
  color: #6c757d;
}

.dashboard-settings-link {
  color: #012e40;
  font-size: 18px;
  margin-left: auto;
  cursor: pointer;
}

@media only screen and (max-width: 1100px) {
  .dashboard-plan {
    font-size: 10px;
  }

  .dashboard-setting {
    bottom: 41px;
    left: 45px;
  }
}

@media only screen and (max-width: 500px) {
  .dashboard-profile {
    padding: 8px 8.6px;
  }

  .dashboard-setting {
    bottom: 46px;
    left: 45px;
  }

  .dashboard-heading {
    font-size: 14px;
  }
}
</style>
